'use strict'

exports.PROTOCOL_ID = '/multistream/1.0.0'
